import { render } from "./formSubmission.vue?vue&type=template&id=67305c70"
import script from "./formSubmission.vue?vue&type=script&lang=js"
export * from "./formSubmission.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__